import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, memo } from 'react';
import { Button } from '@deliveryhero/armor';
import { useDatePickerActionBarClassNames } from './hooks/useDatePickerActionBarClassNames';
import { useDatePickerActionBar } from './hooks/useDatePickerActionBar';
import { DatePickerActionBarRoot, DatePickerActionBarActions } from './style';
import { DATE_PICKER_ACTION_BAR_CLASS_PREFIX } from './constants';
/**
 * @internal
 */
export var DatePickerActionBar = memo(forwardRef(function DatePickerActionBar(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerActionBarClassNames(DATE_PICKER_ACTION_BAR_CLASS_PREFIX, className);
  var _useDatePickerActionB = useDatePickerActionBar(props, ref),
    rootProps = _useDatePickerActionB.rootProps,
    showBar = _useDatePickerActionB.showBar,
    getApplyButtonProps = _useDatePickerActionB.getApplyButtonProps,
    showApplyButton = _useDatePickerActionB.showApplyButton,
    showClearSelectionButton = _useDatePickerActionB.showClearSelectionButton,
    showTodayButtonRegular = _useDatePickerActionB.showTodayButtonRegular,
    showTodayButtonWide = _useDatePickerActionB.showTodayButtonWide,
    getClearSelectionButtonProps = _useDatePickerActionB.getClearSelectionButtonProps,
    getTodayButtonProps = _useDatePickerActionB.getTodayButtonProps;
  return React.createElement(DatePickerActionBarRoot, _objectSpread(_objectSpread({}, rootProps), {}, {
    className: classNameComponents.Root
  }), showBar && React.createElement(DatePickerActionBarActions, {
    className: classNameComponents.Actions
  }, showClearSelectionButton && React.createElement(Button, _objectSpread({
    className: classNameComponents.ActionBarButton,
    tertiary: true,
    danger: true,
    paddingX: 1
  }, getClearSelectionButtonProps()), "Clear"), showTodayButtonRegular && React.createElement(Button, _objectSpread({
    className: classNameComponents.ActionBarButton,
    tertiary: true,
    paddingX: 1
  }, getTodayButtonProps()), "Today")), showApplyButton && React.createElement(Button, _objectSpread(_objectSpread({}, getApplyButtonProps()), {}, {
    className: classNameComponents.ActionBarButtonApply,
    primary: true
  }), "Apply"), showTodayButtonWide && React.createElement(Button, _objectSpread({
    className: classNameComponents.ActionBarButton,
    secondary: true,
    wide: true
  }, getTodayButtonProps()), "Today"));
}));
DatePickerActionBar.displayName = DATE_PICKER_ACTION_BAR_CLASS_PREFIX;